import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
// StrictMode removed: it double-renders every component in dev mode,
// causing out-of-memory crashes with 1,510+ options being computed.
// Production builds are unaffected (StrictMode is dev-only anyway).
// reportWebVitals also removed (Session 39 — file was missing): Performance.measure()
// crashed with "Data cannot be cloned, out of memory" on large rows data anyway.
root.render(<App />);
